import Vue from "vue";
import {
	AclInstaller,
	AclCreate,
	AclRule
} from "vue-acl";
import router from "@/siteRouter";
import themeConfig from "@/../siteThemeConfig.js";

Vue.use(AclInstaller);

/*
let userInfo = JSON.parse(localStorage.getItem("userInfo"))
if(userInfo && userInfo.userRole) initialRole = userInfo.userRole
const timeout = ms => new Promise(resolve => setTimeout(resolve, ms));
*/

var rules = {
	admin: new AclRule("admin").generate(),
	historicoAlteracao: new AclRule("historicoAlteracao").generate(),
	modificar: new AclRule("modificar").generate(),
	editor: new AclRule("editor").generate(),
};

//rules.bancoSangueManifestoTransporte = new AclRule("bancoSangueManifestoTransporte").or(rules.admin).generate();

//rules[themeConfig.userDefaultRole] = new AclRule(themeConfig.userDefaultRole).or("admin").or("editor").generate();
rules[themeConfig.userDefaultRole] = new AclRule(themeConfig.userDefaultRole)
	.or(rules.editor)
	.or(rules.admin)
	.generate();

window.aclrules = AclRule;
//console.log('rules', rules);
//window.testrules = rules;

export default new AclCreate({
	initial: themeConfig.userDefaultRole,
	notfound: "/unauthorized",
	router,
	acceptLocalRules: true,
	globalRules: rules
	/*,
	middleware: async acl => {
		console.log('ACL MIDDLE START');
		//await timeout(2000); // call your api
		console.log('ACL MIDDLE END');
		//console.log(acl);
		//console.log(this.$store.getters.isUserLoggedIn);
		//acl.change('admin')
	}*/
});
